var _style, _path, _g, _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitaminCDeficiency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#F18E23;}\n\t.st2{fill:#538430;}\n\t.st3{fill:#F9C17A;}\n\t.st4{opacity:0;clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,64C71.9,69.1,58.2,90.7,62.8,113c4.5,22.3,25.2,35.2,50.7,30c25.4-5.2,39.4-25.2,34.9-47.4 C143.8,73.3,122.7,58.8,97.3,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.7,61.1c-26,5.3-41.8,27.9-36.8,52.5c4.9,24.1,27.7,37.6,54.1,32.2c26.4-5.4,42.1-26.8,37.1-50.9 C146.1,70.4,122.7,55.8,96.7,61.1z M112.9,140.1c-23.5,4.8-42.9-6.6-47.2-27.7c-4.4-21.7,9.1-40.9,32.3-45.6 c23.1-4.7,43.1,7.6,47.6,29.3C149.8,117.2,136.4,135.3,112.9,140.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.7,72.2l-8.9-2.1c-0.9-0.2-1.8,0.3-2,1.2c-0.2,0.9,0.3,1.8,1.2,2l8.9,2.1c0.2,0.1,0.5,0.1,0.7,0 c0.6-0.1,1.1-0.6,1.3-1.2C106.1,73.3,105.6,72.4,104.7,72.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.5,68.7l-7.4,5.5c-0.7,0.5-0.9,1.6-0.3,2.3c0.4,0.5,1.1,0.8,1.7,0.6c0.2,0,0.5-0.1,0.7-0.3l7.4-5.5 c0.7-0.5,0.9-1.6,0.3-2.3C104.3,68.3,103.2,68.2,102.5,68.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.3,109.1c-1.6-1.1-3.7-0.7-4.8,0.8c-1.1,1.6-0.7,3.7,0.8,4.8c1.6,1.1,3.7,0.7,4.8-0.8 C80.3,112.3,79.9,110.2,78.3,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.8,121.3c-0.7,1.1-0.5,2.5,0.6,3.3c1.1,0.7,2.5,0.5,3.3-0.6c0.7-1.1,0.5-2.5-0.6-3.3 C81.1,120,79.6,120.2,78.8,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.6,127.4c-0.6,0.9-0.4,2,0.5,2.6c0.9,0.6,2,0.4,2.6-0.5c0.6-0.9,0.4-2-0.5-2.6 C90.3,126.3,89.1,126.5,88.6,127.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaminCDeficiency);
export default __webpack_public_path__ + "static/media/Vitamin_C_Deficiency.2e11ad29b26b1bd97ff6940ee464e8c7.svg";
export { ForwardRef as ReactComponent };